@if (showAsDialog) {
  <div class="modal-header">
    <h2 class="modal-title">Family Detail</h2>
  </div>
}



<div class="page-content page-fill">
  <div class="dx-toolbar mb-3">
    <!-- <button (click)="close()" class="btn btn-primary" [hidden]="hasChanges">Close</button> -->
    <dx-button text="Close" type="default" (onClick)="close()" [visible]="!hasChanges"></dx-button>
    <dx-button text="Delete" type="danger" class="ms-3" (onClick)="deleteFamily()" [visible]="!hasChanges && family?.members.length === 0"></dx-button>
    <button (click)="save()" class="btn btn-success" [hidden]="!hasChanges">Save</button>
    <button (click)="cancel()" class="btn btn-default" [hidden]="!hasChanges">Cancel</button>
    <h2 class="d-block ms-4">{{ family?.name }}</h2>
  </div>
  <div class="d-flex">
    <dx-form [formData]="family" [colCount]="2" class="flex-fill" [readOnly]="showAsDialog" >
      <dxi-item [itemType]="'group'" [colCount]="2">
        <dxi-item dataField="homePhone" [label]="{ text: 'Phone' }"></dxi-item>
        <dxi-item dataField="isHomePhoneUnlisted" [label]="{ text: 'Unlisted' }" editorType="dxCheckBox"></dxi-item>
        <dxi-item dataField="address1" [colSpan]="2"></dxi-item>
        <dxi-item dataField="address2" [colSpan]="2"></dxi-item>
        <dxi-item dataField="city"></dxi-item>
        <dxi-item
          dataField="state"
          [label]="{ text: 'State' }"
          editorType="dxSelectBox"
          [editorOptions]="{ items: states, valueExpr: 'text', displayExpr: 'text' }"
        ></dxi-item>
        <dxi-item dataField="zip"></dxi-item>
        <dxi-item dataField="country"></dxi-item>
      </dxi-item>
      <dxi-item [itemType]="'group'">
        <dxi-item
          dataField="familyStatusId"
          [label]="{ text: 'Family Status' }"
          editorType="dxSelectBox"
          [editorOptions]="{ items: familyStatuses, valueExpr: 'id', displayExpr: 'name' }"
        ></dxi-item>
        <dxi-item dataField="includeInDirectory" editorType="dxCheckBox"></dxi-item>
        <dxi-item
          dataField="householdId"
          [label]="{ text: 'Household' }"
          editorType="dxSelectBox"
          [editorOptions]="{ items: households, valueExpr: 'id', displayExpr: 'name' }"
          >
        </dxi-item>
        <dxi-item dataField="note" [editorType]="'dxTextArea'" [editorOptions]="{ height: '100px' }"></dxi-item>
      </dxi-item>
    </dx-form>
    @if (photoUrl) {
      <div class="ms-3" style="width: 300px">
        <img src="{{ photoUrl }}" class="w-100" />
      </div>
    }
  </div>
  <dx-tab-panel
        [items]="[
            { title: 'Members', template: 'membersTemplate' },
            { title: 'Photos', template: 'photosTemplate' }
        ]"
    class="mt-3"
    >
    <div *dxTemplate="let item of 'membersTemplate'">
      <div class="m-3">
        @if (family) {
          <dx-data-grid
            #familyPeopleGrid
            [dataSource]="family.members"
            keyExpr="id"
            height="300px"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            >
            <dxi-column dataField="firstName"></dxi-column>
            <dxi-column dataField="lastName"></dxi-column>
            <dxi-column dataField="relationship.name" caption="Relationship"></dxi-column>
            <dxi-column dataField="email"></dxi-column>
            <dxi-column dataField="birthDateLocal" caption="Birthday" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
            <dxi-column dataField="personStatus.name" caption="Person Status"></dxi-column>
            <div *dxTemplate="let data of 'toolbarButtons'">
              <dx-button
                text="Open"
                type="default"
                (onClick)="open(familyPeopleGrid.focusedRowKey)"
                class="me-3"
                [disabled]="hasChanges || showAsDialog"
              ></dx-button>
              <dx-button text="Add New" type="normal" (onClick)="open()" [disabled]="hasChanges || showAsDialog"></dx-button>
              <dx-button
                text="Add Existing"
                type="normal"
                (onClick)="addExisting(familyPeopleGrid.focusedRowKey)"
                [disabled]="hasChanges || showAsDialog"
              ></dx-button>
              <dx-button
                class="ms-3"
                text="Remove"
                type="danger"
                (onClick)="delete(familyPeopleGrid.focusedRowKey)"
                [disabled]="hasChanges || !familyPeopleGrid.focusedRowKey || showAsDialog"
              ></dx-button>
            </div>
          </dx-data-grid>
        }
      </div>
    </div>
    <div *dxTemplate="let item of 'photosTemplate'">
      <div class="m-3">
        <dx-button text="Directory Photo" type="default" (onClick)="setDirectoryPhoto()" [disabled]="!selectedPhoto || selectedPhoto.photo.isDirectoryPhoto"></dx-button>
        <dx-button text="Delete" type="danger" class="ms-3" (onClick)="deletePhoto()" [disabled]="!selectedPhoto"></dx-button>
        <!-- <dx-button
        class="ms-2"
        text="Delete"
        type="danger"
        (onClick)="deletePhoto()"
        [disabled]="!selectedPhoto"
      ></dx-button> -->
      <button type="button" class="btn btn-secondary ms-5 fa fa-undo" (click)="rotateImage(-90)" [disabled]="!selectedPhoto || showAsDialog"></button>
      <button type="button" class="btn btn-secondary ms-1 me-3 fa fa-repeat" (click)="rotateImage(90)" [disabled]="!selectedPhoto || showAsDialog"></button>
    </div>
    <div class="m-3 d-flex">
      @for (photo of photos; track photo) {
        <div
          class="me-3 border-primary"
          style="width: 300px; border-width: 3px !important"
          [ngClass]="{ border: photo.photo.id === selectedPhoto?.photo.id }"
          >
          <img src="{{ photo.url }}" class="w-100" (click)="selectPhoto(photo)" />
        </div>
      }
    </div>
    @if (!hasChanges && !showAsDialog) {
      <dx-file-uploader
        selectButtonText="Select photos"
        [multiple]="true"
        accept="image/*"
        uploadMode="useButtons"
        (onUploaded)="photoUploaded()"
        [uploadUrl]="serviceName + '/api/utility/UploadMemberPhoto/' + family.id"
        [uploadHeaders]="uploadHeaders"
        >
      </dx-file-uploader>
    }
  </div>
</dx-tab-panel>
</div>
@if (showAsDialog) {
  <div class="modal-footer">
    <button (click)="closeDialog()" class="btn btn-secondary">Close</button>
  </div>
}
